/**
 * Which display this browser tab is. A browser that is a screen keeps one display, remembered across reloads and
 * restarts: that's /display, what a real TV opens. The Pair display sheet's "Open test screen" and "Copy link" add
 * ?new, which makes a brand-new display with a new pairing code every time it's opened, even in a browser that is
 * already another screen. Its own place (?d=…, put in the address at once) keeps that display through reloads.
 *
 * Nothing secret is in the address: the slot only says which of this browser's own saved display sign-ins to use. The
 * same address opened anywhere else has no such sign-in, so it starts as a new display with its own code; the code
 * itself is made by the database when the display signs in, never carried in a link.
 */

const SLOT = /^[a-z0-9]{8,16}$/;
let slot: string | null = null;

function newSlot() {
  const b = new Uint8Array(8);
  crypto.getRandomValues(b);
  return Array.from(b, (x) => (x % 36).toString(36)).join('');
}

/** '' for the browser's own display; otherwise this tab's own display's name. */
export function displaySlot(): string {
  if (slot !== null) return slot;
  slot = '';
  try {
    const url = new URL(location.href);
    if (!url.pathname.startsWith('/display')) return slot;
    if (url.searchParams.has('new')) {
      slot = newSlot();
      url.searchParams.delete('new');
      url.searchParams.set('d', slot);
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    } else {
      const d = url.searchParams.get('d') ?? '';
      if (SLOT.test(d)) slot = d;
    }
  } catch { /* no address to read: the browser's own display */ }
  return slot;
}

/** A storage key for this display: the plain key for the browser's own display, a separate one for each other. */
export const slotKey = (key: string) => (displaySlot() ? `${key}:${displaySlot()}` : key);

/** The Pair display sheet's link: opens a new display with a new code each time. */
export const newDisplayPath = '/display?new';
